import { Dispatch, SetStateAction } from 'react'
import {
  Filter,
  SearchProductsResponse,
} from 'src/services/searchProducts/dtos'
import { FilterProduct } from 'src/templates/SearchAndCategory'

export type IdentifyFilterProps = {
  setArrayFilters: Dispatch<SetStateAction<Partial<FilterProduct>[]>>
  setSelectedFilter: Dispatch<SetStateAction<Partial<FilterProduct>>>
  URLFilter: string[]
  filters: Filter[]
  results: SearchProductsResponse
}

/**
 * Reconstructs the active filter state from the URL query strings.
 *
 * URL formats:
 *   Discrete  : "d:{facet}:{label}"
 *   Continuous: "c:{facet}:{label}:{min}:{max}"
 *
 * Matching strategy:
 *   - Filter group matched by filter.id === facet (string)
 *   - Discrete value matched by String(value.id) === decodedLabel
 *   - Continuous matched by filter.type === 'continuous'
 */
export const identifyFilter = ({
  setArrayFilters,
  setSelectedFilter,
  URLFilter,
  filters,
}: IdentifyFilterProps) => {
  if (!URLFilter?.length) {
    setSelectedFilter({
      tipo: '',
      id_atributo: '',
      id_valor_unidade: '',
      valor_minimo: null,
      valor_maximo: null,
      descricao: '',
      label: '',
    })
    return setArrayFilters([])
  }

  const availableFilters = filters ?? []
  const arrayFiltrosCompleto: Partial<FilterProduct>[] = []

  for (const filtro of URLFilter) {
    // Strip "filtro=" prefix if present (URL query value format)
    const entry = filtro.startsWith('filtro=') ? filtro.slice(7) : filtro
    const parts = entry.split(':')
    const prefix = parts[0]

    if (prefix === 'd' && parts.length >= 3) {
      const facet = parts[1]
      const label = decodeURIComponent(parts.slice(2).join(':'))

      const filterGroup = availableFilters.find(
        (f) => f.values[0]?.idO === facet
      )
      if (!filterGroup) continue

      const matchedValue = filterGroup.values.find(
        (v) => String(v.id ?? '') === label
      )

      arrayFiltrosCompleto.push({
        tipo: 'discrete',
        id_atributo: facet,
        id_valor_unidade: label,
        valor_minimo: null,
        valor_maximo: null,
        descricao: filterGroup.attribute,
        label: matchedValue?.label ?? label,
        queryFiltro: `filtro=${entry}`,
      })
    } else if (prefix === 'c' && parts.length >= 5) {
      // Format: c:{facet}:{label}:{min}:{max}
      const facet = parts[1]
      const label = decodeURIComponent(parts[2])
      const min = parts[3]
      const max = parts[4]

      const filterGroup = availableFilters.find(
        (f) => f.values[0]?.idO === facet && f.type === 'continuous'
      )
      if (!filterGroup) continue

      arrayFiltrosCompleto.push({
        tipo: 'continuous',
        id_atributo: facet,
        id_valor_unidade: label,
        valor_minimo: min,
        valor_maximo: max,
        descricao: filterGroup.attribute,
        label: filterGroup.attribute,
        queryFiltro: `filtro=${entry}`,
      })
    }
  }

  setArrayFilters(arrayFiltrosCompleto)
}
